export function hamburger() {
  const trigger = document.querySelector('.js-hamburgerTrigger');
  const content = document.querySelector('.js-hamburgerCont');
  const menuLinks = content.querySelectorAll('a');
  const overlay = document.querySelector('.js-hamburgerOverlay');

  const navOpen = () => {
    trigger.classList.toggle('is-active');
    content.classList.toggle('is-view');
    overlay.classList.toggle('is-view');
  }

  const navClose = () => {
    trigger.classList.remove('is-active');
    content.classList.remove('is-view');
    overlay.classList.remove('is-view');
  }

  trigger.addEventListener('click', navOpen);
  overlay.addEventListener('click', navClose);
  menuLinks.forEach(element => {
    element.addEventListener('click', navClose);
  });
}